import { defineComponent as v, useSlots as B, computed as l, createBlock as c, openBlock as u, unref as r, mergeProps as A, h as m, withCtx as f, renderSlot as T, createCommentVNode as g, createTextVNode as j, toDisplayString as E } from "vue";
import F from "./highrise402.mjs";
import { getInitials as x } from "./highrise403.mjs";
import { JSONtoNaiveVars as I } from "./highrise343.mjs";
import "./highrise59.mjs";
import { getColorFromString as V } from "./highrise404.mjs";
import { avatarTextSizes as M, getSizeStyles as O } from "./highrise405.mjs";
import { validateSize as $, fallbackSize as S } from "./highrise406.mjs";
import { COMPONENT_NAME as P } from "./highrise178.mjs";
import R from "./highrise407.mjs";
import w from "./highrise84.mjs";
const D = v({
  name: P.AVATAR,
  inheritAttrs: !0
}), Z = /* @__PURE__ */ v({
  ...D,
  props: {
    id: {
      type: String,
      default: void 0
    },
    size: {
      type: String,
      default: "xs",
      validator: $
    },
    objectFit: {
      type: String,
      default: "fill"
    },
    round: {
      type: Boolean,
      default: !0
    },
    src: {
      type: String,
      default: void 0
    },
    name: {
      type: String,
      default: void 0
    },
    preferredInitialsBgColor: {
      type: String
    }
  },
  emits: ["error", "click"],
  setup(e, { emit: z }) {
    const s = z, a = e, i = B(), y = l(() => ({
      "hr-avatar__container": !0,
      [`hr-avatar-${S(a.size)}`]: !0
    })), k = l(() => {
      let t = M[S(a.size)];
      return a.round && (t = {
        ...t,
        borderRadius: "50%"
      }), I(t);
    }), C = l(() => {
      var n, o;
      const t = a.name || ((o = (n = i.default) == null ? void 0 : n.call(i)[0]) == null ? void 0 : o.children) || "";
      if (t)
        return V(t.toString());
    }), h = () => m("div", { class: "flex margin-auto " }, [m(F, { class: "hr-avatar" })]), p = l(
      () => ({
        "2xl": "4xl",
        xl: "4xl",
        lg: "4xl",
        md: "4xl",
        sm: "xs",
        xs: "2xs",
        "2xs": "4xs",
        "3xs": "4xs"
      })[a.size ?? "xs"]
    ), b = (t) => {
      s("error", t);
    }, N = (t) => {
      s("click", t);
    };
    return (t, n) => (u(), c(r(R), A({
      id: e.id,
      class: y.value,
      style: {
        backgroundColor: e.preferredInitialsBgColor ? e.preferredInitialsBgColor : C.value,
        ...k.value
      },
      round: e.round,
      src: e.src ?? null,
      size: r(O)(e.size),
      "object-fit": e.objectFit,
      "render-fallback": h
    }, t.$attrs, {
      onError: b,
      onClick: N
    }), {
      default: f(() => {
        var o, d;
        return [
          (o = r(i)) != null && o.default && !e.name ? T(t.$slots, "default", { key: 0 }) : g("", !0),
          e.name && !((d = r(i)) != null && d.default) ? (u(), c(r(w), {
            key: 1,
            size: p.value
          }, {
            default: f(() => [
              j(E(e.size === "3xs" ? r(x)(e.name, 1) : r(x)(e.name)), 1)
            ]),
            _: 1
          }, 8, ["size"])) : g("", !0)
        ];
      }),
      _: 3
    }, 16, ["id", "class", "style", "round", "src", "size", "object-fit"]));
  }
});
export {
  Z as default
};
